(() => {
  window.addEventListener("abra:cart:changed", () => {
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  });

  window.addEventListener("DOMContentLoaded", () => {
    async function checkCartLineItems() {
      const lineItemCount = document.querySelectorAll("td line-item")?.length;

      if (lineItemCount) {
        const response = await fetch(
          window.Shopify.routes.root + "cart.js?_abraignore=1",
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        const cart = await response.json();

        if (cart && cart.items.length !== lineItemCount) {
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
      }
    }

    if (window?.Abra?.template?.name === "cart") {
      checkCartLineItems();
    }
  });
})();
